export default __webpack_public_path__ + "static/media/icon_level_target_date_calendar.3a550a48.svg";